<template>
  <div id="pwd_verify_outer">
    <span v-for="(item, index) in itemList"
          :class="[passwordVeriValue == (index + 1) ? 'active' : '']"
          :key="'pwd_ver_index_' + (index + 1)" >{{item}}</span>
  </div>
</template>

<script>
export default {
  name: "PasswordVerifiy",
  props: {
    password: {
      type: String,
      value: '',
    }
  },
  data() {
    return {
      title: '密码强度验证',
      itemList: ['弱', '中', '强'],
    }
  },
  computed: {
    passwordVeriValue() {
      if (this.password == null) {
        return  -1;
      }
      return this.password.pwdLevel();
    }
  }
}
</script>

<style scoped>

  #pwd_verify_outer {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: nowrap;
  }

  #pwd_verify_outer span {
    display: inline-block;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    background-color: gray;
    padding: 2px 20px;
    border-radius: 2px;
  }


  #pwd_verify_outer span.active {

    background-color: #fc1a34;

  }
</style>



// WEBPACK FOOTER //
// src/components/PasswordVerifiy.vue